import { FbTextField } from "@flexibees/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { axiosPostWithToken, axiosPut } from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "../actions/commonAction";

const SelectField = ({ label, fieldKey, value, onChange, style, children }) => (
  <FbTextField
    id="outlined-select-currency"
    select
    required
    label={label}
    fullWidth={!style}
    value={value}
    InputLabelProps={{ shrink: true }}
    SelectProps={{
      IconComponent: KeyboardArrowDownIcon,
      MenuProps: {
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        PaperProps: { style: { maxHeight: 350, zIndex: 1302 } },
        getContentAnchorEl: null,
      },
    }}
    onChange={(e) => onChange(e.target.value, fieldKey)}
    variant="outlined"
    style={style}
  >
    {children}
  </FbTextField>
);

export default SelectField;


export const submitKycRequest = ({
  apiUrl,
  formData,
  edit,
  token,
  dispatch,
  callback,
  successMessage = "Updated Successfully",
}) => {
  const request = edit
    ? axiosPut(apiUrl, formData, token)
    : axiosPostWithToken(apiUrl, formData, token);

  return request
    .then((res) => {
      if (res?.data?.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: res.data.data.message || successMessage,
        });
        if (callback) callback();
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res.data.data.errors.pan ||res.data.message||  "Something went wrong while saving KYC details.",
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while saving KYC details.",
      });
    });
};